export const FallbackImage = () => (
  <img
    src="/homepage/assets/card-fallback.webp"
    width="100%"
    height="auto"
    alt=""
    style={{ aspectRatio: '2' }}
  />
)
